module.exports = __webpack_public_path__ + "img/GooglePlay-left.4b551be3.png";